// extracted by mini-css-extract-plugin
export default {"firstBlock":"howTo_firstBlock__Fd0ad","serviceInfo":"howTo_serviceInfo__+aNBW","instructions":"howTo_instructions__7EPWF","result":"howTo_result__b59+h"};